<template>
  <div class="header">
    <v-toolbar
      height="85"
      flat
    >
      <LogoImage />
      <v-spacer />
      <template v-if="isLogged">
        <NotResponsiveNavigation
          class="header-not-responsive"
          @logout="handleLogout()"
        />
        <ResponsiveNavigation
          class="header-responsive"
          @open="handleOpenDialog()"
        />
      </template>
    </v-toolbar>
    <HeaderDialog
      v-model="dialog"
      @logout="handleLogout()"
    />
    <v-divider />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import HeaderDialog from './HeaderDialog'
import LogoImage from './LogoImage'
import NotResponsiveNavigation from './NotResponsiveNavigation'
import ResponsiveNavigation from './ResponsiveNavigation'
import { LOGGED_USER_KEY, ACTION_LOGOUT } from '../../store/types/user.types'


export default {
  name: 'Header',
  components: {
    HeaderDialog,
    LogoImage,
    NotResponsiveNavigation,
    ResponsiveNavigation,
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    isLogged() {
      return this.loggedUser !== null
    },
    ...mapState({
      loggedUser: state => state.user[LOGGED_USER_KEY],
    }),
  },
  methods: {
    handleLogout() {
      this.logout()
    },
    handleOpenDialog() {
      this.dialog = true
    },
    ...mapActions({
      logout: ACTION_LOGOUT,
    }),
  },
}
</script>
<style scoped>
.header >>> .theme--light {
    background-color: white;
}

.header >>> .theme--light:before {
  background-color: transparent;
 }

.header >>> .v-btn__content {
  font-size: 16px;
}

.header-responsive {
  display: none;
}

.header-not-responsive {
  display: initial;
}

@media only screen and (max-width: 960px) {
  .header-responsive {
    display: initial;
  }

  .header-not-responsive {
    display: none;
  }
}
</style>
